import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import _ from 'lodash';

import AutoComplete from '../../Common/AutoComplete/index';
import ReduxDialog from '../../Common/ReduxDialog/index';
import { hideDialog, showDialog } from '../../../redux/actions/dialogs';
import { fetchEmployeesRoutine } from '../../../redux/routines';
import { customizedFuzzyFilter, sortStrings } from '../../../utils/helper';
import { assignResourcesToTasks } from '../../../redux/actions/tasks';
import icons from '../../../utils/icons';

import styles from './styles';
import { ASSIGN_EMPLOYEES_TO_STAGES_DIALOG } from '../../../redux/constants/dialogs';
import { getDialogContextValue } from '../../../redux/selectors';

const employeeDSConfig = {
  text: 'name',
  value: 'id',
};

class AssignEmployeesToStagesDialog extends React.Component {
  static propTypes = {
    // onRequestClose: PropTypes.func.isRequired,
    job: PropTypes.object.isRequired,
    stages: PropTypes.array,
    employees: PropTypes.array,
    hideDialog: PropTypes.func.isRequired,
    fetchEmployees: PropTypes.func.isRequired,
    assignResourcesToTasks: PropTypes.func.isRequired,
    tasks: PropTypes.array,
  };

  state = {
    stages: {},
  };

  componentWillMount() {
    this.props.fetchEmployees();
  }

  handleSelectEmployee = (stageId, employeeId) => {
    this.setState({
      stages: _.assign({}, this.state.stages, { [stageId]: { assignedTo: employeeId } }),
    });
  };

  handleSave = () => {
    this.props.assignResourcesToTasks(this.props.tasks, this.state.stages);
    this.props.hideDialog(ASSIGN_EMPLOYEES_TO_STAGES_DIALOG);
  };

  renderStage(stage) {
    return (<TableRow key={stage.id} displayBorder={false}>
      <TableCell style={styles.stageCol}>
        <img src={icons[stage.icon]} style={styles.stageIcon} alt={stage.name}/> {stage.name}
      </TableCell>
      <TableCell>
        <AutoComplete
          name="employee"
          textFieldStyle={styles.autocomplete}
          dataSource={this.props.employees}
          dataSourceConfig={employeeDSConfig}
          filter={customizedFuzzyFilter}
          hintText="Employee"
          openOnFocus
          onNewRequest={(employee) => this.handleSelectEmployee(stage.id, employee.id)
          }
          fullWidth
        />
      </TableCell>
    </TableRow>);
  }

  renderStages() {
    return (<div>
      <div>
        <Table selectable={false}>
          <TableHead style={styles.tableHeader} displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow displayBorder={false}>
              <TableCell style={styles.stageCol}>Stage</TableCell>
              <TableCell>Employee</TableCell>
            </TableRow>
          </TableHead>
          <TableBody displayRowCheckbox={false}>
            { this.props.stages ? this.props.stages.map((stage) => this.renderStage(stage)) : '' }
          </TableBody>
        </Table>
      </div>
    </div>);
  }

  render() {
    const buttons = [<Button
      variant="text"
      color="primary"
      onClick={() => this.props.hideDialog(ASSIGN_EMPLOYEES_TO_STAGES_DIALOG)}
    >Cancel</Button>,
      <Button
        variant="text"
        color="primary"
        autoFocus
        onClick={() => this.handleSave()}
      >Save</Button>];
    return (
      <ReduxDialog
        name="assignEmployeesToStages"
        title={'Stage Assignment'}
        actions={buttons}
        bodyStyle={styles.body}
      >
        { this.renderStages() }
      </ReduxDialog>
    );
  }
}

function mapStateToProps(state) {
  const job = state.get('jobs').get('job').toJS();
  const resources = _.values(job.resources || {}).filter((resource) => resource.employeeId).map((resource) => resource.employeeId);
  const employees = state.get('employees').get('employees').toJS().filter((employee) => resources.indexOf(employee.id) >= 0).sort((a, b) => sortStrings(a.name, b.name));

  console.log('resources', resources);
  console.log('employees', employees);

  const context = getDialogContextValue(state);

  return {
    job,
    stages: context(ASSIGN_EMPLOYEES_TO_STAGES_DIALOG, 'stages').toJS(),
    tasks: context(ASSIGN_EMPLOYEES_TO_STAGES_DIALOG, 'tasks').toJS(),
    employees,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployees: fetchEmployeesRoutine.trigger,
    hideDialog,
    showDialog,
    assignResourcesToTasks,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignEmployeesToStagesDialog);



// WEBPACK FOOTER //
// ./src/components/Jobs/AssignEmployeesToStagesDialog/index.js